import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import { useCropperState, useCropperDispatch, actions } from '../../model';

const { setZoom, setCrop, setCroppedAreaPxls } = actions;

const StateContext = createContext();
const ActionsContext = createContext();

export const useCropBlockState = () => useContext(StateContext);
export const useCropBlockActions = () => useContext(ActionsContext);

const Provider = ({ aspect, children, hasZoom }) => {
  const { fileSrc, crop, zoom, initialCroppedArea } = useCropperState();

  const [height, setHeight] = useState(600);

  const dispatch = useCropperDispatch();

  const onZoomChange = useCallback((zoom) => dispatch(setZoom(zoom)), []);

  const onCropChange = useCallback((crop) => dispatch(setCrop(crop)), []);

  const onCropComplete = useCallback((_croppedArea, croppedAreaPixels) => {
    dispatch(setCroppedAreaPxls(croppedAreaPixels));
  }, []);

  const onMediaLoaded = useCallback((size) => {
    setHeight(size.height);
  }, []);

  const state = useMemo(
    () => ({
      fileSrc,
      crop,
      zoom,
      initialCroppedArea,
      aspect,
      height,
      hasZoom,
    }),
    [fileSrc, crop, zoom, initialCroppedArea, aspect, height, hasZoom]
  );

  const actions = useMemo(
    () => ({
      onZoomChange,
      onCropChange,
      onCropComplete,
      onMediaLoaded,
    }),
    [onZoomChange, onCropChange, onCropComplete, onMediaLoaded]
  );

  return (
    <StateContext.Provider value={state}>
      <ActionsContext.Provider value={actions}>
        {children}
      </ActionsContext.Provider>
    </StateContext.Provider>
  );
};

export default Provider;
